// extracted by mini-css-extract-plugin
module.exports =  {"remoteness":"_93444fe79c--remoteness--IsLTB"};